import { listCoupons } from '@/services/academy/coupons.service'

export default {
	namespaced: true,
	state: {
		list:       { data: [], meta: { total: 0 } },
		listStatus: 'init',
	},
	getters: {
		getList:       (s) => s.list,
		getListStatus: (s) => s.listStatus,
	},
	mutations: {
		SET_LIST(state, v)        { state.list = v },
		SET_LIST_STATUS(state, v) { state.listStatus = v },
	},
	actions: {
		async fetchList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await listCoupons(params)
				commit('SET_LIST', data)
				commit('SET_LIST_STATUS', 'init')
			} catch {
				commit('SET_LIST_STATUS', 'error')
			}
		},
	},
}
